import { render } from "./BalTabs.vue?vue&type=template&id=369e3db0&ts=true"
import script from "./BalTabs.vue?vue&type=script&lang=ts"
export * from "./BalTabs.vue?vue&type=script&lang=ts"

import "./BalTabs.vue?vue&type=style&index=0&id=369e3db0&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__